export default {
  namespaced: true,
  hikvision_camera: {
    title: "Cámara Hikvision | Cámaras Hikvision",
    hikvision: 'hikvision',
    name: "nombre",
    dvr: "DVR",
    status: "estado",
    type: "tipo"
  }
};
